import { TwitterLogo, LinkedinLogo, InstagramLogo, FacebookLogo, YoutubeLogo, GithubLogo, TiktokLogo } from "@phosphor-icons/react";

const PLATFORM_ICONS = {
  twitter: TwitterLogo,
  linkedin: LinkedinLogo,
  instagram: InstagramLogo,
  facebook: FacebookLogo,
  youtube: YoutubeLogo,
  github: GithubLogo,
  tiktok: TiktokLogo,
};

export const SocialIcons = ({ links }) => {
  const activeLinks = (links || []).filter((l) => l.url);
  if (activeLinks.length === 0) return null;

  return (
    <div className="flex items-center gap-3">
      {activeLinks.map((link) => {
        const Icon = PLATFORM_ICONS[link.platform] || null;
        if (!Icon) return null;
        return (
          <a
            key={link.platform}
            href={link.url}
            target="_blank"
            rel="noreferrer"
            data-testid={`footer-social-${link.platform}`}
            className="flex items-center justify-center w-9 h-9 rounded-full border border-slate-200 dark:border-white/10 text-slate-500 dark:text-slate-400 hover:text-teal-500 dark:hover:text-teal-400 hover:border-teal-400/50 transition-colors duration-300"
          >
            <Icon size={16} weight="bold" />
          </a>
        );
      })}
    </div>
  );
};
